import React from 'react'
import { Button } from '@mobi/component-library/Common/V2/Buttons/Button'
import { Ticket } from '@core/Areas/AccountActivity/types'
import { RaceNotificationButton } from '@core/Areas/Racing/Components/RaceNotificationButton'
import { TicketLayoutType } from '../../helpers'

export const RaceAlertButton: React.FC<{
  ticket: Ticket
  ticketLayoutType: TicketLayoutType
}> = ({ ticket, ticketLayoutType }) => {
  const leg = ticket.legs[0]

  const isSingleRace =
    ticketLayoutType === 'single-single' ||
    ticketLayoutType === 'single-multiple' ||
    ticketLayoutType === 'same-race-multi'

  const canSetAlert =
    isSingleRace && leg.meetingName && leg.raceNumber && leg.fixtureDate && leg.fixtureId

  if (!canSetAlert) {
    return null
  }

  return (
    <span data-testid='ticket-footer-alert-button'>
      <RaceNotificationButton
        raceStatus='Pending'
        raceTime={new Date(leg.advertisedStartTime)}
        meetingName={leg.meetingName}
        raceNumber={leg.raceNumber}
        meetingDate={leg.fixtureDate}
        meetingId={leg.fixtureId}
        buttonComponent={ButtonComponent}
      />
    </span>
  )
}

// ===============
// Local Component
// ===============

const ButtonComponent: React.FC<React.HTMLAttributes<HTMLButtonElement>> = ({
  onClick,
  children,
  ...attributes
}) => (
  <Button
    // @ts-expect-error Prop name clashes with attribute
    color='tertiary_grey'
    size='xs'
    onClick={onClick}
    {...attributes}
  >
    {children} Alert
  </Button>
)
